<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}个无形资产信息</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd">新增</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" type="danger" size="small" :disabled="multiple" v-preventReClick @click="handleDelete">删除</el-button>
          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange" @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <el-table ref="multipleTable" border row-key="id" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
        </el-table-column>
        <el-table-column prop="no" label="资产名称" min-width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span><br />
            <span>{{ scope.row.no }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="price" label="单价" min-width="100" :formatter="toDecimal4">
        </el-table-column>
        <el-table-column prop="assetTypeName" label="资产类型" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="unitName" label="单位" min-width="80" show-overflow-tooltip></el-table-column>
        <el-table-column prop="financeTypeName" label="财务分类" width="120"></el-table-column>
        <el-table-column prop="productSourceName" label="产品来源" width="120"></el-table-column>
        <!-- <el-table-column prop="createdTime" label="创建时间" width="130">
          <template slot-scope="scope">
            <div>
              {{ parseTime(new Date(scope.row.createdTime), "{y}-{m}-{d}") }}
            </div>
            <div>
              {{ parseTime(new Date(scope.row.createdTime), "{h}:{i}:{s}") }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" label="更新时间" width="130">
          <template slot-scope="scope">
            <div>
              {{ parseTime(new Date(scope.row.updateTime), "{y}-{m}-{d}") }}
            </div>
            <div>
              {{ parseTime(new Date(scope.row.updateTime), "{h}:{i}:{s}") }}
            </div>
          </template>
        </el-table-column> -->
        <el-table-column prop="stateName" label="资产状态" width="80">
          <template slot-scope="scope">
            <span :class="{
                enable: scope.row.state == 1,
                forbidden: scope.row.state == 0,
              }">{{ scope.row.stateName }}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="isWorkflowTable" label="审批人" width="100" align="center" prop="approverNames" />
        <el-table-column prop="statusName" label="评估状态" width="120" v-if="isWorkflowTable">
          <template slot-scope="scope">
            <approve-status :row="scope.row" :canSuccessAgain="true" :isWorkflowTable="isWorkflowTable" :options="AssessmentStatusOptions" @success="getData" :tableCode="route.name"></approve-status>
          </template>
        </el-table-column>

        <el-table-column prop="remark" label="备注" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="operation" label="操作" width="180">
          <template slot-scope="scope">
            <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button>
            <!-- <el-button type="text" v-preventReClick
            @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
            <el-button type="text" v-preventReClick
            @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button> -->

            <el-button v-if="
                scope.row.status == 1 &&
                  isShowApproveButton(scope.row.approverIds)
              " type="text" v-preventReClick @click="handleApprove(scope.row)" class="margin-left20 color-blue">审核</el-button>
            <el-button v-else-if="
                scope.row.status != 1 && tableAcl.indexOf('Edit') != -1
              " type="text" v-preventReClick @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
            <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span>
            <el-button v-if="tableAcl.indexOf('Remove') != -1" type="text" v-preventReClick @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <info :show="showInfo" :id="id" @handleClose="closeInfo"></info>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { RemoveNoneAssets, GetNoneAssets, IsEnablePassWord } from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import Info from "./info";
import SelectFilter from "@/components/table-select-filter";
import { WhetherOptions } from "@/enum";
import BaseListMixin from '@/mixin/baseList-mixin.js'

export default {
  mixins: [GetDataMixin, BaseListMixin],
  components: { Info, SelectFilter },
  data () {
    return {
      GetDatasAction: GetNoneAssets,
      RemoveAction: RemoveNoneAssets,
      // PrintAction: GetAcceptInStockPrintData,
      editPath: 'none-asset-edit',
      // // 查询条件
      // query: {
      //   keyWord: "",
      //   pageSize: 10,
      //   pageIndex: 1,
      // },
      // // 列表数据
      // tableData: [],
      // // 列表总数
      // total: 0,
      // // 弹出框标题
      // title: "",
      // // 弹出编辑框
      // open: false,
      // // 打开详情
      showInfo: false,
      id: 0,
      // // 新增、编辑的数据
      // form: {},
      // // 多选框数据
      // ids: [],
      // multipleSelection: [],
      // // 列表多选
      // multiple: true,
      WhetherOptions: WhetherOptions,
      filterOptions: [
        {
          name: "资产类型",
          type: "selectTree",
          code: "assetTypeId",
          filterMethod: this.getNoneAssetTrees,
          data: [],
          defaultProps: {
            children: "children",
            label: "name",
          },
          text: "",
        },
        {
          name: "财务分类",
          type: "selectTree",
          code: "financeTypeId",
          filterMethod: this.getFinanceTypes,
          data: [],
          defaultProps: {
            children: "children",
            label: "name",
          },
          text: "",
        },
        {
          name: "产品来源",
          type: "select",
          code: "assetSource",
          filterMethod: this.getProductSource,
          data: [],
        },
        {
          name: "是否效益资产",
          type: "select",
          code: "isBenefit",
          data: WhetherOptions,
        },
        {
          name: "日期范围",
          type: "date",
          code: "date",
        },
      ],
    };
  },
  methods: {
    // handleSelectionChange (selection) {
    //   this.multipleSelection = selection;
    //   this.ids = selection.map((item) => item.id);
    //   this.multiple = !selection.length;
    // },
    // // 获取列表
    // getData () {
    //   GetNoneAssets(this.query).then((res) => {
    //     this.tableData = res.returnData.data;
    //     this.total = res.returnData.totalCount;
    //   });
    // },
    // // 查看信息
    handleInfo (row) {
      this.id = row.id;
      this.checkNeedPassword();
    },
    closeInfo () {
      this.showInfo = false;
      this.id = 0;
    },
    // // 新建
    // handleAdd () {
    //   this.$router.push("/none-asset-edit?formMode=1");
    // },
    // // 编辑
    // handleUpdate (row) {
    //   this.$router.push("/none-asset-edit?formMode=2&id=" + row.id);
    // },
    // // 审批
    // handleApprove (row) {
    //   this.$router.push("/none-asset-edit?formMode=3&id=" + row.id);
    // },
    checkNeedPassword () {
      IsEnablePassWord({ id: this.id }).then((res) => {
        this.canRead = !res.returnData;
        if (res.returnData) {
          // 需要验证密码
          this.showInfo = true;
        } else {
          // this.getInfo();
          this.$router.push("/none-asset-edit?formMode=0&id=" + this.id);
        }
      });
    },
    // // 改变当前页
    // changePage (val) {
    //   this.$set(this.query, "pageIndex", val);
    //   this.getData();
    // },
    // handleSizeChange (val) {
    //   this.$set(this.query, "pageSize", val);
    //   this.getData();
    // },
    // // 删除部门
    // handleDelete (row) {
    //   const ids = row && row.id ? [row.id] : this.ids;

    //   this.$my_confirm(
    //     "您正在执行删除无形资产的操作，删除后无法恢复，请谨慎操作！",
    //     "提示",
    //     {
    //       type: "warning",
    //     }
    //   )
    //     .then(() => {
    //       return RemoveNoneAssets({ ids });
    //     })
    //     .then(() => {
    //       this.$my_message(`操作成功！`, "success");
    //       this.getData();
    //     })
    //     .catch(() => { });
    // },
    // // 重置
    // reset () {
    //   this.query = {
    //     keyWord: "",
    //     pageSize: 10,
    //     pageIndex: 1,
    //   };
    //   if (this.$refs["selectFilter"]) {
    //     this.$refs["selectFilter"].resetQuery();
    //   }
    //   this.ids = []
    //   this.multipleSelection = []
    //   this.multiple = true;

    //   if (this.$refs.multipleTable) {
    //     this.$refs.multipleTable.clearSelection()
    //   }
    //   this.getData();
    // },
    // queryChange () {
    //   this.$set(this.query, "pageIndex", 1);
    //   this.getData();
    // },
    toDecimal4 (row, column, cellValue, index) {
      return "￥" + this.toDecimal(cellValue, 4);
    },
  },
  mounted () {
    // this.getData();
  },
};
</script>

<style lang="scss" scoped></style>
